export default __webpack_public_path__ + "static/media/12.afe6a864.png";